import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useClientHeight } from "@/hooks/useClientHeight";
import { Button, Result } from "@/ui";
import { StyledErrorFallback } from "./styled";

const ErrorFallback: FC = () => {
  const height = useClientHeight();

  const { t } = useTranslation();

  const onClickTryAgain = () =>{
    window.location.reload();
  };

  return (
    <StyledErrorFallback $height={height}>
      <Result
        title={t('error')}
        message={t('something_went_wrong')}
        image="error.svg"
      >
        <Button onClick={onClickTryAgain}>{t('try_again')}</Button>
      </Result>
    </StyledErrorFallback>
  );
};

export default ErrorFallback;